import React from 'react';

import {
  IconButton,
  IconButtonProps,
  iconButtonClasses,
  styled,
} from '@mui/material';

import {
  COLOR_BORDER,
  COLOR_DARK,
  COLOR_DARKER,
  COLOR_DISABLED,
  COLOR_FOCUS,
  COLOR_TRANSPARENT,
} from '~/components/App/theme';

interface IAnnotationIconButton extends IconButtonProps {
  selected?: boolean;
  selector?: 'fill' | 'stroke';
  width?: number;
  height?: number;
  // https://github.com/mui/material-ui/issues/31194
  component?: React.ElementType;
}

export const AnnotationIconButton = styled(IconButton)<IAnnotationIconButton>((props) => {
  const { selected, selector = 'fill', width = 32, height = 32, theme } = props;
  const {
    palette: {
      primary: { light: COLOR_LIGHT },
      secondary,
      background,
    },
  } = theme;
  return {
    width,
    height,
    borderRadius: 4,
    background: selected ? background.default : COLOR_TRANSPARENT,
    path: {
      [selector]: selected ? COLOR_DARKER : COLOR_LIGHT,
    },
    rect: {
      fill: COLOR_TRANSPARENT,
      stroke: selected ? COLOR_DARKER : COLOR_LIGHT,
    },
    '&:focus-visible': {
      outline: `3px solid ${COLOR_FOCUS}`,
    },
    [`&.${iconButtonClasses.colorPrimary}:hover`]: {
      background: background.default,
      path: {
        [selector]: COLOR_DARK,
      },
      rect: {
        stroke: COLOR_DARK,
      },
    },
    [`&.${iconButtonClasses.colorSecondary}`]: {
      background: COLOR_TRANSPARENT,
      border: `1px solid ${COLOR_BORDER}`,
      borderRadius: 4,
    },
    [`&.${iconButtonClasses.colorSecondary}:hover`]: {
      background: COLOR_TRANSPARENT,
      path: {
        [selector]: secondary.main,
      },
    },
    [`&.${iconButtonClasses.disabled}`]: {
      path: {
        [selector]: COLOR_DISABLED,
      },
      rect: {
        stroke: COLOR_DISABLED,
      },
    },
    '&:active': {
      path: {
        [selector]: COLOR_DARKER,
      },
      rect: {
        stroke: COLOR_DARKER,
      },
    },
  };
});
